import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { boxGrade, boxType } from '../../../../constants/nft';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import {
  statisticsNFTBoxExcelDataRequest,
  statisticsNFTBoxListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import SimpleLine from '../ChartComponents/SimpleLine';
import Notification from '../../../../components/Notification/Notification';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import BtnIcons from '../../../../api/images/btnIcons';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import DataItem from "../DataItem";
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringNftCarBox from "../../../../schema/table-schema/useSchemaMonitoringNftCarBox";
import {
    SearchBtn,
    SearchBtnContainer,
    SearchContainer,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";
import FetchLoading from "../../../../components/Loading/FetchLoading";

function carBox() {
  // -- component const --//
  // 상자 타입
  const boxTypes = Object.keys(boxType).map(key => ({
    key: boxType[key],
    value: key.toString(),
  }));

  // 상자 등급
  const boxRarity = Object.keys(boxGrade).map(key => ({
    key: boxGrade[key],
    value: key.toString(),
  }));

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [NFTGradeTable, setNFTGradesTable] = useState([]);
  const [NFTTypeTable, setNFTTypesTable] = useState([]);

  const schema = useSchemaMonitoringNftCarBox();
  const [data, setData] = useState([{}]);
  const [lineData, setLineData] = useState([{}]);

  const [NFTGrade, setNFTGrades] = useState([]);
  const [NFTType, setNFTTypes] = useState([]);

  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  // Excel Data
  const [excelData, setExcelData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    // const {
    //   target: { value },
    // } = event;

    // 전체 선택시 빈값으로 대치
    const value = event.target.value.includes('')
      ? ['']
      : event.target.value;

    if (type === 'grade') {
      setNFTGrades(value);
    } else if (type === 'type') {
      setNFTTypes(value);
    } else if (type === 'grade-table') {
      setNFTGradesTable(value);
    } else if (type === 'type-table') {
      setNFTTypesTable(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraph(true);

    dispatch(
      statisticsNFTBoxListRequest({
        beginDate: startAt,
        endDate: endAt,
        boxType: '',
        boxGrade: '',
        callback: (data) => {
          console.log('요청 결과: ', data);
          setData(data?.list)

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );

    dispatch(
      statisticsNFTBoxExcelDataRequest({
        beginDate: startAt,
        endDate: endAt,
        callback: (data) => {
          console.log('요청 결과: ', data);
          const updatedData = data?.list.map((item) => {
            const averageHolderCount = item?.totalHolderCount !== 0 ? item?.totalSpendingCount / item?.totalHolderCount : 0;
            return {
              ...item,
              averageHolderCount,
            };
          });
          setExcelData(updatedData);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    );

  }

  const handleClickDownload = () => {
    // 파일 명 설정
    const fileName = `NFT_차량_상자_${startAt}_${endAt}`;

    excelDownload(fileName, excelData, sortKey.statistics.nft_carBox);
  };

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);

  useEffect(() => {
    fetchList();

    setIsLoading(true);

    // 스펜딩 현황 조회
    dispatch(
      statisticsNFTBoxListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        boxType: '',
        boxGrade: '',
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list)

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, []);

  useEffect(() => {
    // 조건에 따른 스펜딩 현황 조회
    setIsLoading(true);

    dispatch(
      statisticsNFTBoxListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        boxType: NFTTypeTable.map(item => String(item)).join(','),
        boxGrade: NFTGradeTable.map(item => String(item)).join(','),
        callback: (data) => {
          console.log('요청 결과: ', data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [NFTTypeTable, NFTGradeTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  useEffect(() => {
    const updateData = data && data?.map(data => {
      // 스펜딩 현황
      const totalSpendingCount = data?.totalSpendingCount || 0;

      const newDate = timeFormAPI.changeDataDate(data?.targetDate);

      return {
        '총 스펜딩 수': totalSpendingCount,
        time: newDate,
      }
    });

    setLineData(updateData)
  }, [data]);

  useEffect(() => {
    const updateData = strData && strData.map(data => {
      // 스펜딩 현황
      const totalSpendingCount = data?.totalSpendingCount || 0;
      const totalHolderCount = data?.totalHolderCount || 0;
      const averageHolderCount = (totalSpendingCount / totalHolderCount) || 0;
      const regularCount = data?.regularCount || 0;

      const walletToSpendingCount = data?.walletToSpendingCount || 0;
      const spendingToWalletCount = data?.spendingToWalletCount || 0;

      const targetDate = data?.targetDate;

      return {
        totalSpendingCount: totalSpendingCount,
        averageHolderCount: averageHolderCount.toFixed(2),
        regularCount: regularCount,

        walletToSpendingCount: walletToSpendingCount,
        spendingToWalletCount: spendingToWalletCount,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);
  }, [strData]);


  // -- render --//
  return(
    <>

        <div className="contentsArea">

          <div className="rowDiv">
            <div className="leftDiv" style={{width:'100%'}}>
              <div className={"contentTitle"}>
                스펜딩 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준) ` }
              </div>
            </div>

            <div className="rightDiv" style={{justifyContent: "flex-end"}}>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={NFTTypeTable}
                    onChange={(event) => handleChange(event, 'type-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>차량 상자 종류</div>;
                      }

                      return selected
                          .map((value) => boxTypes.find((item) => item?.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={NFTTypeTable.length === boxTypes.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setNFTTypesTable(checked ? boxTypes.map((item) => item?.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {boxTypes.map((item) => (
                      <MenuItem
                          key={item?.value}
                          value={item?.value}
                          style={{
                            padding: 5,
                            gap: 5
                          }}
                      >
                        <input
                            type="checkbox"
                            checked={NFTTypeTable.includes(item?.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setNFTTypesTable((prevNFTTypesTable) => {
                                if (checked) {
                                  return [...prevNFTTypesTable, item?.value];
                                } else {
                                  return prevNFTTypesTable.filter((value) => value !== item?.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item?.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={NFTGradeTable}
                    onChange={(event) => handleChange(event, 'grade-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>차량 상자 등급</div>;
                      }

                      return selected
                          .map((value) => boxRarity.find((item) => item?.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={NFTGradeTable.length === boxRarity.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setNFTGradesTable(checked ? boxRarity.map((item) => item?.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {boxRarity.map((item) => (
                      <MenuItem
                          key={item?.value}
                          value={item?.value}
                          style={{
                            padding: 5,
                            gap: 5
                          }}
                      >
                        <input
                            type="checkbox"
                            checked={NFTGradeTable.includes(item?.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setNFTGradesTable((prevNFTGradesTable) => {
                                if (checked) {
                                  return [...prevNFTGradesTable, item?.value];
                                } else {
                                  return prevNFTGradesTable.filter((value) => value !== item?.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item?.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          {
            isLoading ?
                <FetchLoading/>
              : tableData.slice(0, -1)
              .map((data, index) => (

                <div key={index} style={{padding: "10px 15px"}}>
                  <div className="rowDiv" style={{
                    width: '100%',
                    height: '100%',
                    padding: 5
                  }}>

                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%'
                    }}>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <DataItem
                            label="총 스펜딩"
                            value={tableData[index + 1]?.totalSpendingCount}
                            prevValue={tableData[index]?.totalSpendingCount}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="홀더 평균 보유"
                            value={tableData[index + 1]?.averageHolderCount}
                            prevValue={tableData[index]?.averageHolderCount}
                            targetDate={tableData[index + 1]?.targetDate}
                        />

                        <DataItem
                            label="레귤러"
                            value={tableData[index + 1]?.regularCount}
                            prevValue={tableData[index]?.regularCount}
                            targetDate={tableData[index + 1]?.targetDate}
                        />
                      </div>

                      <div className="spaceDiv10"/>
                      <div className="spaceDiv10"/>

                      <div style={{ display: 'flex', gap: 5 }}>
                        <DataItem
                            label={'월렛 ➝ 스펜딩'}
                            value={tableData[index + 1]?.walletToSpendingCount}
                            prevValue={tableData[index]?.walletToSpendingCount}
                            targetDate={tableData[index + 1]?.targetDate}
                            style={{ width: '100%' }}
                        />

                        <DataItem
                            label={'스펜딩 ➝ 월렛'}
                            value={tableData[index + 1]?.spendingToWalletCount}
                            prevValue={tableData[index]?.spendingToWalletCount}
                            targetDate={tableData[index + 1]?.targetDate}
                            style={{ width: '100%' }}
                        />
                      </div>


                    </div>
                  </div>
                </div>

              ))
          }

        </div>

        <div className="spaceDiv10"/>

      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
            <SearchBtn
                handleSearchClick={() => {
                    fetchList();
                }}
            />
        </SearchRow>
        {/*<SearchBtnContainer*/}
        {/*    handleSearchClick={() => {*/}
        {/*      fetchList();*/}
        {/*    }}*/}
        {/*    handleResetClick={() => {*/}
        {/*      location.reload();*/}
        {/*    }}*/}
        {/*/>*/}

      </SearchContainer>

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        분포 지표*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}

      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="spaceDiv10"/>*/}
      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList();*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn fit purple" onClick={handleClickDownload}>*/}
      {/*        <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*/}
      {/*        엑셀 다운로드*/}
      {/*      </button>*/}

      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className="spaceDiv10"/>*/}

      {/*  /!*{*!/*/}
      {/*  /!*  isLoadingGraph ? (*!/*/}
      {/*  /!*      <div className="rowDiv" style={{*!/*/}
      {/*  /!*        width: '100%',*!/*/}
      {/*  /!*        height: 520,*!/*/}
      {/*  /!*        display: 'flex',*!/*/}
      {/*  /!*        justifyContent: 'center',*!/*/}
      {/*  /!*        padding: 'unset'*!/*/}
      {/*  /!*      }}>*!/*/}
      {/*  /!*        Loading...*!/*/}
      {/*  /!*      </div>*!/*/}
      {/*  /!*    )*!/*/}
      {/*  /!*    : <div className="rowDiv" style={{*!/*/}
      {/*  /!*  height: 520,*!/*/}
      {/*  /!*  padding: 'unset'*!/*/}
      {/*  /!*}}>*!/*/}
      {/*  /!*  <div className="descDiv" style={{*!/*/}
      {/*  /!*    width: '100%',*!/*/}
      {/*  /!*    height: '100%'*!/*/}
      {/*  /!*  }}>*!/*/}
      {/*  /!*    <SimpleLine data={lineData}/>*!/*/}
      {/*  /!*  </div>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*  /!*}*!/*/}
      {/*</div>*/}


      <div className="spaceDiv10"/>

      <BOTable
          rows={data}
          schema={schema}
          loading={isLoadingGraph}
          maxHeight={"65vh"}
      />


      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </>
  )
}

export default carBox;
